import { selectFromUserDto } from '../../models';

export default selectFromUserDto()
  .id
  .organizationId
  .email
  .fullname
  .roles(b => b.name)
  .toString();
